import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import classNames from 'classnames';

import { generateCenteredColumnSpanClassNames } from '../../../../utils/Utils';

export default class YoutubeVideo extends Component {
  render() {
    const { columnWidths, links = [] } = this.props;
    const columnWidthsClassNames = generateCenteredColumnSpanClassNames(columnWidths);
    const [{ href }] = links;

    return (
      <div className="video-grid">
        <div className={classNames('video-wrapper', columnWidthsClassNames)} >
          <LazyLoad>
            <iframe
              width="1120"
              height="630"
              src={href}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </LazyLoad>
        </div>
      </div>
    );
  }
}
